import EntityMultiSelect, { selectedEntityIds } from '../../../../shared/components/EntityMultiSelect';
import { mandateFormSchema } from './documentCreation.schemas';
import React from 'react';
import { Button } from '@/shared/ui/button';
import { Checkbox } from '@/shared/ui/checkbox';
import { Input } from '@/shared/ui/input';
import { Label } from '@/shared/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/shared/ui/select';
import ClientCustomFieldsSection from '../../../clients/components/ClientCustomFieldsSection';
import { archiveDocumentsCustomField, createDocumentsCustomField, listDocumentsCustomFields } from '../../services/documents-custom-fields.service';

const MANDATE_CUSTOM_FIELDS_API = { list: listDocumentsCustomFields, create: createDocumentsCustomField, archive: archiveDocumentsCustomField };

export default function CreateMandateForm({
  clients,
  clientsUnavailable = false,
  form,
  isSubmitting,
  onFieldChange,
  onSubmit,
  enableCustomFields = false,
  renderActions = true,
}) {
  return (
    <div className="space-y-6 py-4">
      <div className="bg-[var(--chart-accent-1-soft)] p-4 rounded-lg border border-[var(--border)]">
        <h3 className="font-semibold text-[var(--chart-accent-1)] mb-3">Dati Principali</h3>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <Label htmlFor="mandate-client">Cliente *</Label>
            <EntityMultiSelect label="Clienti" options={clients} value={selectedEntityIds(form, 'client')} required
              onChange={(ids) => onFieldChange('clientIds', ids)} />
            {clientsUnavailable ? (
              <p role="alert" className="mt-1 text-xs wt-inline-error">
                Metadata clienti non disponibili. Generazione mandato temporaneamente limitata.
              </p>
            ) : null}
          </div>
          <div>
            <Label htmlFor="mandate-signer-role">{mandateFormSchema.field('formData.firmatarioRuolo').label}</Label>
            <Input id="mandate-signer-role" value={form.firmatarioRuolo} onChange={(event) => onFieldChange('firmatarioRuolo', event.target.value)} className="mt-1" />
          </div>
          <div>
            <Label htmlFor="mandate-credit-type">{mandateFormSchema.field('formData.tipoCrediti').label} *</Label>
            <Input id="mandate-credit-type" required value={form.tipoCrediti} onChange={(event) => onFieldChange('tipoCrediti', event.target.value)} className="mt-1" />
          </div>
          <div>
            <Label htmlFor="mandate-credit-status">{mandateFormSchema.field('formData.statoCrediti').label}</Label>
            <Input id="mandate-credit-status" value={form.statoCrediti} onChange={(event) => onFieldChange('statoCrediti', event.target.value)} className="mt-1" />
          </div>
          <div>
            <Label htmlFor="mandate-nominal-value">{mandateFormSchema.field('formData.valoreNominale').label}</Label>
            <Input id="mandate-nominal-value" value={form.valoreNominale} onChange={(event) => onFieldChange('valoreNominale', event.target.value)} className="mt-1" />
          </div>
          <div>
            <Label htmlFor="mandate-estimated-value">{mandateFormSchema.field('formData.valoreStimato').label}</Label>
            <Input id="mandate-estimated-value" value={form.valoreStimato} onChange={(event) => onFieldChange('valoreStimato', event.target.value)} className="mt-1" />
          </div>
          <div>
            <Label htmlFor="mandate-commission">{mandateFormSchema.field('formData.commissionePercentuale').label}</Label>
            <Input id="mandate-commission" value={form.commissionePercentuale} onChange={(event) => onFieldChange('commissionePercentuale', event.target.value)} className="mt-1" />
          </div>
          <div>
            <Label htmlFor="mandate-signing-mode">{mandateFormSchema.field('formData.modalitaFirma').label}</Label>
            <Input id="mandate-signing-mode" value={form.modalitaFirma} onChange={(event) => onFieldChange('modalitaFirma', event.target.value)} className="mt-1" />
          </div>
          <div>
            <Label htmlFor="mandate-start-date">{mandateFormSchema.field('formData.dataInizio').label} *</Label>
            <Input id="mandate-start-date" required type="date" value={form.dataInizio} onChange={(event) => onFieldChange('dataInizio', event.target.value)} className="mt-1" />
          </div>
          <div>
            <Label htmlFor="mandate-end-date">{mandateFormSchema.field('formData.dataScadenza').label}</Label>
            <Input id="mandate-end-date" type="date" value={form.dataScadenza} onChange={(event) => onFieldChange('dataScadenza', event.target.value)} className="mt-1" />
          </div>
          <div className="col-span-2">
            <Label htmlFor="mandate-signing-place">{mandateFormSchema.field('formData.luogoFirma').label}</Label>
            <Input id="mandate-signing-place" value={form.luogoFirma} onChange={(event) => onFieldChange('luogoFirma', event.target.value)} className="mt-1" />
          </div>
        </div>
      </div>

      <div className="space-y-3">
        <div className="flex items-center gap-2">
          <Checkbox id="mandate-privacy" checked={form.accettazionePrivacy} onCheckedChange={(value) => onFieldChange('accettazionePrivacy', Boolean(value))} />
          <label htmlFor="mandate-privacy" className="text-sm text-[var(--text-primary)]">Accetto informativa privacy</label>
        </div>
        <div className="flex items-center gap-2">
          <Checkbox id="mandate-terms" checked={form.accettazioneTermini} onCheckedChange={(value) => onFieldChange('accettazioneTermini', Boolean(value))} />
          <label htmlFor="mandate-terms" className="text-sm text-[var(--text-primary)]">Accetto termini e condizioni</label>
        </div>
      </div>

      {enableCustomFields ? (
        <ClientCustomFieldsSection
          formKey="documents.mandate.create"
          values={form.customFields || {}}
          onChange={(customFields) => onFieldChange('customFields', customFields)}
          api={MANDATE_CUSTOM_FIELDS_API}
        />
      ) : null}

      {renderActions ? <div className="flex gap-2">
        <Button
          className="flex-1 bg-[var(--chart-accent-1)] hover:bg-[var(--chart-accent-1)] text-[var(--on-primary)]"
          disabled={isSubmitting}
          onClick={onSubmit}
        >
          {isSubmitting ? 'Generazione in corso...' : 'Genera Mandato'}
        </Button>
      </div> : null}
    </div>
  );
}
